import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href", "download"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed, onBeforeMount, ref } from 'vue'

import { platform } from '@/services/platform'
import { apiURL } from '@/services/request'
import type { DocView } from '@/models/doc'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'PdfDownloadLink',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props

const isAndroid = ref(false)
const showSpinner = ref(false)

const spinnerDelay = ref(4000)

onBeforeMount(async () => {
  // The `download` link property does not work on Android (just nothing happens
  // when clicking the link, no error and no download).
  // So we are rendering the link without that property.
  // In other cases, the property is usefl and browsers handle the file download
  // in a better way.
  //
  // Note: the problem with the `download` property is not generic, it is also related
  // to the app url, as download worked for me when I set app URL to local,
  // like http://192.168.88.254:8080/app and the pdf URL starts with
  // http://192.168.88.254:5000/api in this case.
  // While on dev URLs are https://dev.shortform.com/app and https://dev.shortform.com/api
  // and the download does not work.
  isAndroid.value = await platform.isNativeAndroidApp()
})

async function registerDocExport(): Promise<void> {
  props.doc.registerDocExport()

  if (isAndroid.value) {
    // On Android, the link from the `<a>` tag doesn't open
    // in the browser, so we have to open it manually.
    await platform.openUrl(downloadUrl.value)
  }

  showSpinner.value = true
  setTimeout(() => (showSpinner.value = false), spinnerDelay.value)
}

const downloadName = computed(() => {
  // We replace `/` with `-` in the file name as the server interprets the `/` as a URL
  // path separator and we end up with a 404 error.
  //
  // We can safely do the replacement here: the title can actually be anything and is used
  // for a local file name when the browser saves the PDF.
  // Our backend uses the `token` parameter in the download URL to identify the file.
  const downloadTitle = props.doc.title.replace('/', '-')
  return `${props.doc.exportPdfFileNamePrefix} - ${downloadTitle}.pdf`
})

const downloadUrl = computed(() => {
  const token = assertNotNull(props.doc.doc_export_stats).token
  return apiURL + `pdfdocs?token=${token}`
})

return (_ctx: any,_cache: any) => {
  const _component_button_spinner = _resolveComponent("button-spinner")!

  return (isAndroid.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: downloadUrl.value,
        target: "_blank",
        class: "btns",
        onClick: _withModifiers(registerDocExport, ["prevent"])
      }, " Download PDF ", 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("a", {
        key: 1,
        href: downloadUrl.value,
        target: "_blank",
        class: "btns",
        download: downloadName.value,
        onClick: registerDocExport
      }, [
        (!showSpinner.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Download PDF"))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _cache[0] || (_cache[0] = _createTextVNode("Downloading", -1)),
              _createVNode(_component_button_spinner)
            ]))
      ], 8, _hoisted_2))
}
}

})